import { render } from "./button-color.vue?vue&type=template&id=0e352c4c&scoped=true"
import script from "./button-color.vue?vue&type=script&lang=js"
export * from "./button-color.vue?vue&type=script&lang=js"

import "./button-color.vue?vue&type=style&index=0&id=0e352c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e352c4c"]])

export default __exports__